import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import SEO from "@/components/SEO";

export default function PaiementAnnule() {
    return (
        <>
            <SEO title="Paiement annulé — Mon Séraphin" description="Paiement annulé. Vous pouvez reprendre votre réservation." path="/paiement/annule" noindex />
            <Navbar />
            <main className="min-h-screen pt-32 pb-20 px-6 md:px-12 flex items-center" data-testid="payment-cancelled-page">
                <div className="max-w-2xl mx-auto text-center">
                    <XCircle className="w-16 h-16 text-zinc-500 mx-auto" />
                    <h1 className="mt-8 font-display text-5xl text-white font-light">Paiement annulé</h1>
                    <p className="mt-4 text-zinc-400 text-lg">
                        Pas d'inquiétude, aucune somme n'a été prélevée. Vous pouvez reprendre votre réservation à tout moment.
                    </p>
                    <div className="mt-10 flex gap-3 justify-center">
                        <Link to="/reserver" className="rounded-full bg-amber-400 text-black px-6 py-3 font-medium hover:bg-amber-300" data-testid="cancel-retry-btn">
                            Reprendre la réservation
                        </Link>
                        <Link to="/" className="rounded-full border border-white/20 text-white px-6 py-3 hover:border-amber-400/60">
                            Accueil
                        </Link>
                    </div>
                </div>
            </main>
            <Footer />
        </>
    );
}
